import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { CloudTwinSharedModule } from '@cloud-twin-v2/cloud-twin-shared/cloud-twin-shared.module';
import { MeasurementsFiltrableItemService } from '@cloud-twin-v2/cloud-twin-shared/filtrable-items/services/ct-measurement-filtrable-item.service';
import { ResultsFiltrableItemService } from '@cloud-twin-v2/cloud-twin-shared/filtrable-items/services/ct-result-filtrable-item.service';
import { CtMapSharedModule } from '@cloud-twin-v2/ct-map/ct-map-shared.module';
import { CTResultsFormatService } from '@cloud-twin-v2/ct-map/services/ct-results-format.service';
import { ConfigurableFormModule } from '@common-modules/configurable-form/configurable-form.module';
import { CommonSharedModule } from '@common-modules/shared/common-shared.module';
import { WidgetRegistryService } from '@common-modules/widget-registry/widget-registry';
import { GenericChartsModuleSettings } from '@common-modules/wlm-charts/generic-charts-module-settings';
import { GenericChartsModule } from '@common-modules/wlm-charts/generic-charts.module';
import { QuillModule } from 'ngx-quill';
import { CreateDashboardWidgetCartComponent } from './create-dashboard-widget-cart/create-dashboard-widget-cart.component';
import { CreateDashboardWidgetFormComponent } from './create-dashboard-widget-form/create-dashboard-widget-form.component';
import { CreateDashboardWidgetPopupComponent } from './create-dashboard-widget-popup/create-dashboard-widget-popup.component';
import { CtAttributesSelectorComponent } from './ct-attributes-selector/ct-attributes-selector.component';
import { CtDashboardsService } from './ct-dashboards.service';
import { DashboardCategoryChartSettingsComponent } from './dashboard-category-chart-settings/dashboard-category-chart-settings.component';
import { DashboardCategoryChartWidgetComponent } from './dashboard-category-chart-widget/dashboard-category-chart-widget.component';
import { DashboardChartSettingsComponent } from './dashboard-chart-settings/dashboard-chart-settings.component';
import { DashboardChartWidgetComponent } from './dashboard-chart/dashboard-chart-widget.component';
import { CTCustomizableChartDataService } from './dashboard-chart/services/ct-customizable-chart-data.service';
import { CTCustomizableChartService } from './dashboard-chart/services/ct-customizable-chart.service';
import { DashboardChildConfigPopupComponent } from './dashboard-child-config-popup/dashboard-child-config-popup.component';
import { DashboardChildConfigComponent } from './dashboard-child-config/dashboard-child-config.component';
import { DashboardGridSettingsComponent } from './dashboard-grid-settings/dashboard-grid-settings.component';
import { DashboardGridWidgetComponent } from './dashboard-grid-widget/dashboard-grid-widget.component';
import { DashboardHeaderToolbarComponent } from './dashboard-header-toolbar/dashboard-header-toolbar.component';
import { DashboardTextSettingsComponent } from './dashboard-text-settings/dashboard-text-settings.component';
import { DashboardTextWidgetComponent } from './dashboard-text-widget/dashboard-text-widget.component';

@NgModule({
  declarations: [
    CreateDashboardWidgetFormComponent,
    CreateDashboardWidgetPopupComponent,
    CtAttributesSelectorComponent,
    CreateDashboardWidgetCartComponent,
    DashboardHeaderToolbarComponent,
    DashboardChildConfigComponent,
    DashboardChildConfigPopupComponent,

    DashboardChartWidgetComponent,
    DashboardChartSettingsComponent,

    DashboardCategoryChartWidgetComponent,
    DashboardCategoryChartSettingsComponent,

    DashboardGridWidgetComponent,
    DashboardGridSettingsComponent,

    DashboardTextWidgetComponent,
    DashboardTextSettingsComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    CloudTwinSharedModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatRadioModule,
    CtMapSharedModule,
    CommonSharedModule.forFeature({
      filtrableItemServices: [ResultsFiltrableItemService, MeasurementsFiltrableItemService],
    }),
    GenericChartsModule.forFeature(
      new GenericChartsModuleSettings({
        baseCustomizableChartService: CTCustomizableChartService,
        baseCustomizableChartDataService: CTCustomizableChartDataService,
        avoidConversion: true,
      })
    ),
    QuillModule.forRoot(),
    ConfigurableFormModule,
  ],
  providers: [CtDashboardsService, CTResultsFormatService],
})
export class CtDashboardsModule {
  static injector: Injector;
  constructor(injector: Injector, private _widgetRegistry: WidgetRegistryService) {
    CtDashboardsModule.injector = injector;
    this._widgetRegistry.register([
      {
        name: 'DashboardChartWidgetComponent',
        widgetClass: DashboardChartWidgetComponent,
      },
      {
        name: 'DashboardGridWidgetComponent',
        widgetClass: DashboardGridWidgetComponent,
      },
      {
        name: 'DashboardTextWidgetComponent',
        widgetClass: DashboardTextWidgetComponent,
      },
    ]);
  }
}
